import { Route, Routes } from "react-router-dom";
import Loadable from 'react-loadable';
import PageLoader from "components/PageLoader";

const LazyCashier = Loadable({
    loader: () => import("pages/Cashier/index"),
    loading: () => <PageLoader />,
});

const LazyCashierReport = Loadable({
    loader: () => import("pages/CashierRevenue/index"),
    loading: () => <PageLoader />,
});


// const LazyOrderDetail = Loadable({
//     loader: () => import("pages/OrderDetail/index"),
//     loading: () => <PageLoader />,
// });


function CashierRoute() {
    return (
        <Routes>
            <Route path="/" element={<LazyCashier />} />
            <Route path="/report" element={<LazyCashierReport />} />
            {/* <Route path="/detail/:order_id" element={<LazyOrderDetail />} /> */}
        </Routes>
    );
}

export default CashierRoute;
